"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseApi_1 = __importDefault(require("./BaseApi"));
class OAuthApi extends BaseApi_1.default {
    startSession() {
        return this.http.post("/oauth/api/v1/create_session/", null, {
            withCredentials: true,
        });
    }
    getAuthUrl(csrfToken) {
        return this.http.post(`/oauth/api/v1/generate_authorization_redirect_url/`, null, {
            withCredentials: true,
            headers: {
                "X-CSRFToken": csrfToken,
            },
        });
    }
    getAccessToken(csrfToken, authToken) {
        return this.http.post(`/oauth/api/v1/generate_access_token/`, {
            code: authToken,
        }, {
            withCredentials: true,
            headers: {
                "X-CSRFToken": csrfToken,
            },
        });
    }
}
exports.default = OAuthApi;
